import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Pagination from "react-js-pagination";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import NoContentAdded, { NO_TICKET } from "NoContentAdded";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchFormBuilderMaxVersionWise } from "FormBuilderAction";
import {
  fetchSingleCategoryTickets,
  searchSingleCategoryTicket,
  updateFormTickets,
  fetchSettings,
} from "TicketAction";
import LocaleStrings from "Languages";
import { itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import TicketsCell from "./ticketcell";

class TicketAssocLinkModal extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.state = {
      pageNumber: 1,
      selectedTickets: [],
      search: "",
      allCheck: false,
      showModal: false,
      loading: false,
      loadingAssocTicket: false,
      disabled: true,
    };
  }

  componentDidMount() {}

  openModal() {
    var { session, formDetails, userCategoryList } = this.props;
    this.setState({ loadingAssocTicket: true, disabled: true });

    var categoryFilter = "";
    if (formDetails.formtype === "checkout") {
      var attendee = _.filter(userCategoryList, (obj) => {
        return obj.type == "attendee";
      });
      var speaker = _.filter(userCategoryList, (obj) => {
        return obj.type == "speaker";
      });

      categoryFilter = encodeURI(
        `(eventid=${session.eventid})AND((usercategory=${attendee[0].id})OR(usercategory=${speaker[0].id}))`
      );
    } else {
      var cate = _.filter(userCategoryList, (obj) => {
        return obj.type == formDetails.formtype;
      });

      categoryFilter = encodeURI(
        `(eventid=${session.eventid})AND(usercategory=${cate[0].id})`
      );
    }

    // Fetching tictets first time
    this.props.fetchSingleCategoryTickets(
      session,
      0,
      0,
      categoryFilter,
      (responseT) => {
        this.props.fetchFormBuilderMaxVersionWise(
          session,
          formDetails.formid,
          (responseF) => {
            // console.log("responseF :- ", responseF);
            var selected = [];
            var formRelatedInfo = responseF.response;

            if (
              formRelatedInfo &&
              formRelatedInfo.length > 0 &&
              formRelatedInfo[0].tickets_by_formid &&
              formRelatedInfo[0].tickets_by_formid.length > 0
            ) {
              _.map(formRelatedInfo[0].tickets_by_formid, (item) => {
                item.checked = true;
                selected.push(item);
              });
              // this.setState({disabled: false});
            }
            this.checkMatchArray(selected);
            this.setState({
              showModal: true,
              loadingAssocTicket: false,
              selectedTickets: selected,
            });
          }
        );
      }
    );
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  onSearchTicket = (event) => {
    var search = event.target.value;

    var pageNumber = 1;
    this.setState({ search, pageNumber });

    setTimeout(() => {
      this.paginationCallback(pageNumber);
    }, 500);
  };

  paginationCallback = (pageNumber) => {
    let { search, selectedTickets } = this.state;
    var { session, formDetails, userCategoryList } = this.props;

    var categoryFilter = "";
    let searchQuery = "";
    if (formDetails.formtype === "checkout") {
      var attendee = _.filter(userCategoryList, (obj) => {
        return obj.type == "attendee";
      });
      var speaker = _.filter(userCategoryList, (obj) => {
        return obj.type == "speaker";
      });

      categoryFilter = encodeURI(
        `(eventid=${session.eventid})AND((usercategory=${attendee[0].id})OR(usercategory=${speaker[0].id}))`
      );
      searchQuery = encodeURI(
        `(eventid=${session.eventid})AND((usercategory=${attendee[0].id})OR(usercategory=${speaker[0].id}))AND((ticketname like %${search}%)OR(tickecode like %${search}%))`
      );
    } else {
      var cate = _.filter(userCategoryList, (obj) => {
        return obj.type == formDetails.formtype;
      });

      categoryFilter = encodeURI(
        `(eventid=${session.eventid})AND(usercategory=${cate[0].id})`
      );
      searchQuery = encodeURI(
        `(eventid=${session.eventid})AND(usercategory=${cate[0].id})AND((ticketname like %${search}%)OR(tickecode like %${search}%))`
      );
    }

    if (search == "") {
      this.props.fetchSingleCategoryTickets(
        session,
        pageNumber,
        0,
        categoryFilter,
        (response) => {
          this.checkMatchArray(selectedTickets);
        }
      );
    } else {
      this.props.searchSingleCategoryTicket(
        session,
        searchQuery,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(selectedTickets);
        }
      );
    }
    this.setState({ ...this.state, pageNumber });
  };

  selectAllRecords = () => {
    var { selectedTickets, allCheck } = this.state;
    var allTickets = this.props.ticketList.resource;
    var newSelectValue = [];
    var newSelectedValues = [];

    if (allCheck == false) {
      _.map(allTickets, (obj) => {
        var checkUserExitOrNot = _.filter(selectedTickets, function (sel) {
          return sel.id === obj.id;
        });

        //Check if value is not exist in selected values that add
        if (checkUserExitOrNot.length == 0) {
          newSelectValue = { ...obj, checked: true };
          selectedTickets = [...selectedTickets, newSelectValue];
        }
        this.checkMatchArray(selectedTickets);
        this.setState({ selectedTickets, disabled: false });
      });
    } else {
      var leftValue = selectedTickets;
      _.map(allTickets, (obj) => {
        newSelectedValues = _.filter(leftValue, function (sel) {
          return sel.id !== obj.id;
        });
        leftValue = newSelectedValues;

        this.checkMatchArray(leftValue);
        this.setState({ selectedTickets: leftValue, disabled: false });
      });
    }
  };

  checkMatchArray = (selectedValues) => {
    var ticketList = this.props.ticketList.resource;
    var newArray = [];
    _.map(ticketList, (obj) => {
      var newSelectedValues = _.filter(selectedValues, function (sel) {
        return sel.id === obj.id;
      });

      // NEw codes
      if (newSelectedValues && newSelectedValues.length > 0) {
        newArray = [...newArray, newSelectedValues];
      }

      // Olds
      // newSelectedValues.length > 0
      //   ? (newArray = [...newArray, newSelectedValues])
      //   : "";
    });

    // Check for all tickets selected or not according to that check or uncheck master check option
    if (newArray.length > 0 && newArray.length === ticketList.length) {
      this.setState({ allCheck: true });
    } else {
      this.setState({ allCheck: false });
    }
  };

  selectionCallback = (ticket) => {
    var { selectedTickets } = this.state;
    var index = _.findIndex(selectedTickets, function (sel) {
      return sel.id === ticket.id;
    });

    if (index >= 0) {
      var newSelectedValues = _.filter(selectedTickets, function (sel) {
        return sel.id !== ticket.id;
      });
      this.checkMatchArray(newSelectedValues);
      this.setState({ selectedTickets: newSelectedValues, disabled: false });
    } else {
      var selectedValues = { ...ticket, checked: true };
      selectedTickets = [...selectedTickets, selectedValues];
      this.checkMatchArray(selectedTickets);
      this.setState({ selectedTickets, disabled: false });
    }
  };

  renderTicketList() {
    var { selectedTickets } = this.state;
    var ticketList = this.props.ticketList.resource;
    var cells = [];

    _.map(ticketList, (ticket, index) => {
      var selected = selectedTickets.find((obj) => obj.id === ticket.id);
      var checked = false;
      if (selected) {
        checked = selected.checked;
      }
      cells.push(
        <TicketsCell
          key={ticket.id}
          ticket={ticket}
          checked={checked}
          selectedtickets={false}
          toggleSelection={this.selectionCallback}
        />
      );
    });
    return cells;
  }

  renderSelectedList() {
    var { selectedTickets } = this.state;
    var cells = [];

    _.map(selectedTickets, (ticket, index) => {
      var checked = false;
      cells.push(
        <TicketsCell
          key={ticket.id}
          ticket={ticket}
          checked={checked}
          selectedtickets={true}
          removeFromSelected={this.selectionCallback}
        />
      );
    });
    return cells;
  }

  updateAssociatedTickets = () => {
    var { selectedTickets } = this.state;
    var { formDetails, settingInfo } = this.props;

    var eventformid = 0;
    if (formDetails.formtype === "checkout") {
      eventformid =
        settingInfo &&
        settingInfo.resource &&
        settingInfo.resource.length > 0 &&
        settingInfo.resource[0].eventformid
          ? settingInfo.resource[0].eventformid
          : 0;
    } else if (formDetails.formtype === "exhibitor") {
      eventformid =
        settingInfo &&
        settingInfo.resource &&
        settingInfo.resource.length > 0 &&
        settingInfo.resource[0].exhibitorformid
          ? settingInfo.resource[0].exhibitorformid
          : 0;
    } else if (formDetails.formtype === "sponsor") {
      eventformid =
        settingInfo &&
        settingInfo.resource &&
        settingInfo.resource.length > 0 &&
        settingInfo.resource[0].sponsorformid
          ? settingInfo.resource[0].sponsorformid
          : 0;
    }

    confirmAlert({
      title: LocaleStrings.checkout_title_update_ticket_associated_form,
      message: LocaleStrings.checkout_text_sure_want_to_update_with_form_change,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.setState({ loading: true });
            this.props.updateFormTickets(
              this.props.session,
              selectedTickets,
              formDetails.formid,
              eventformid,
              (response) => {
                if (response.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.setState({ loading: false });
                  this.props.showSuccess(
                    LocaleStrings.checkout_form_ticket_association_success
                  );
                  this.closeModal();
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    var { ticketList } = this.props;
    var { selectedTickets, showModal, loadingAssocTicket, disabled } =
      this.state;
    var allListLeft = { borderRight: "1px solid #e6edf3" };
    var allListRight = {};

    if (
      ticketList &&
      ticketList.resource &&
      ticketList.resource.length < 11 &&
      selectedTickets.length > ticketList.resource.length
    ) {
      allListLeft = {};
      allListRight = { borderLeft: "1px solid #e6edf3" };
    }

    return (
      <div>
        <span className="pull-right">
          <Button
            className="btn btn-custom-table-blue"
            loading={loadingAssocTicket}
            onClick={this.openModal}
          >
            <img
              style={{ paddingRight: 10, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
            />
            {LocaleStrings.button_ticket_assoc_link_dynamic_form}
          </Button>
        </span>
        <div>
          <Modal
            className="modal-container"
            show={showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            keyboard={false}
            backdrop="static"
            dialogClassName="modal-xl"
            enforceFocus={false}
            size="xl"
          >
            <Modal.Header className="ticket-association-modal-header-height">
              <div className="import-modal-title">
                <input
                  className="form-control private-user-search"
                  placeholder={`${LocaleStrings.search}....`}
                  type="text"
                  value={this.state.search}
                  onChange={this.onSearchTicket}
                />
              </div>
              <button
                type="button"
                className="i-custom-cross-popup ticket-association-modal-header-button-mt- pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6" style={allListLeft}>
                  <h3>{LocaleStrings.checkout_form_text_ticket_list}</h3>
                  {ticketList &&
                  ticketList.resource &&
                  ticketList.resource.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <label className="checkcontainer">
                              <input
                                type="checkbox"
                                onChange={this.selectAllRecords}
                                checked={this.state.allCheck}
                              />
                              <span className="checkcheckmark" />
                            </label>
                          </th>
                          <th>
                            {
                              LocaleStrings.tickets_ticket_table_list_ticket_name
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody>{this.renderTicketList()}</tbody>
                    </table>
                  ) : (
                    <div
                      style={{ minHeight: 200 }}
                      className="custom-align-center"
                    >
                      <NoContentAdded contentType={NO_TICKET} />
                    </div>
                  )}

                  {ticketList && ticketList.count > itemCount ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={this.props.ticketList.count}
                      pageRangeDisplayed={5}
                      onChange={this.paginationCallback}
                    />
                  ) : null}
                </div>
                <div className="col-md-6" style={allListRight}>
                  <h3>
                    {LocaleStrings.checkout_form_text_selected_ticket_list}
                  </h3>
                  {selectedTickets.length > 0 ? (
                    <div className="scroll-section">
                      <table className="table scrollable-table">
                        <thead>
                          <tr>
                            <th>
                              <div>
                                <span>
                                  {
                                    LocaleStrings.tickets_ticket_table_list_ticket_name
                                  }
                                </span>
                                {selectedTickets.length > 0 ? (
                                  <span className="pull-right">
                                    Total: {selectedTickets.length}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>{this.renderSelectedList()}</tbody>
                      </table>
                    </div>
                  ) : (
                    <div
                      style={{ minHeight: 200 }}
                      className="custom-align-center"
                    >
                      <NoContentAdded contentType={NO_TICKET} />
                    </div>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-blue"
                loading={this.state.loading}
                onClick={this.updateAssociatedTickets}
                disabled={disabled}
              >
                {LocaleStrings.button_ticket_assoc_update}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    ticketList: state.siglrCategoryTicketList,
    settingInfo: state.SettingData,
    userCategoryList: state.userCategoryList.data,
  };
}

export default connect(mapStateToProps, {
  fetchSingleCategoryTickets,
  searchSingleCategoryTicket,
  updateFormTickets,
  showError,
  showSuccess,
  fetchSettings,
  fetchFormBuilderMaxVersionWise,
})(TicketAssocLinkModal);
